import styled from "styled-components";

import { fieldContainerCss } from "../Input/styles";

// Reaproveita o mesmo "field container" (borda, tipografia, destaque de foco) do
// Input padrão em vez de duplicar o CSS. A cor do ícone de WhatsApp é decidida
// inteiramente por quem usa o campo (ver pages/FloatingWhatsapp e pages/Social),
// que já passa o ícone pré-colorido conforme a validade do número.
export const PhoneField = styled.div<{ focus: boolean }>`
  ${fieldContainerCss};
`;

export const StyledPhoneInputWrapper = styled.div`
  flex: 1;
  min-width: 0;
  color: inherit;

  .PhoneInputCountryIcon {
    width: 1.75rem;
    height: 1.1667rem;
    border-radius: 2px;
    overflow: hidden;
    box-shadow: none;
  }

  /* country-flag-icons (passado via prop "flags") devolve um svg cru, sem width/height
     nem classe — react-phone-number-input só aplica .PhoneInputCountryIconImg no
     fallback de img (ver Flag.js). Sem isto o svg renderiza no tamanho intrínseco
     dele mesmo, bem menor que o wrapper já dimensionado acima. */
  .PhoneInputCountryIcon svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  .PhoneInputCountryIconImg {
    display: block;
    width: 100%;
    height: 100%;
  }

  .PhoneInputInput {
    width: 100%;
    min-width: 0;
    margin: 0;
    padding: 1rem 10px 1rem 0;
    border: none;
    background-color: transparent;
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    font-style: inherit;
    font-weight: inherit;
    line-height: inherit;

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: var(--color-neutral-light);
      opacity: 0.7;
    }
  }
`;

export const CountrySelectWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  align-self: stretch;
  margin-right: 0.75rem;
`;

export const CountryButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--color-neutral-white);
  cursor: pointer;

  .PhoneInputCountryIcon {
    width: 1.75rem;
    height: 1.1667rem;
    border-radius: 2px;
    overflow: hidden;
    box-shadow: none;
  }

  .PhoneInputCountryIcon svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  .arrow {
    width: 0.45rem;
    height: 0.45rem;
    margin-left: 0.125rem;
    border-right: 2px solid var(--color-neutral-light);
    border-bottom: 2px solid var(--color-neutral-light);
    transform: rotate(45deg) translateY(-2px);
  }
`;

export const CountryDropdown = styled.div`
  position: absolute;
  top: calc(100% + 0.5rem);
  left: -3rem;
  z-index: 20;
  width: min(18rem, calc(100vw - 3rem));
  overflow: hidden;
  border: 1px solid var(--color-neutral-light);
  border-radius: 0.625rem;
  background: var(--color-neutral-darkness);
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.32);
`;

export const CountrySearch = styled.input`
  width: 100%;
  padding: 0.875rem 1rem;
  border: none;
  border-bottom: 1px solid var(--color-neutral-light);
  background: var(--color-neutral-dark);
  color: var(--color-neutral-white);
  font-family: "Inter", sans-serif;
  font-size: 0.875rem;
  font-weight: 700;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: var(--color-neutral-light);
    opacity: 0.8;
  }
`;

export const CountryDivider = styled.div`
  height: 1px;
  margin: 0.25rem 0;
  background: var(--color-neutral-light);
  opacity: 0.3;
`;

export const CountryOptions = styled.div`
  max-height: min(18rem, 50vh);
  overflow: auto;

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 4px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.32);
  }
`;

type CountryOptionButtonProps = {
  $active: boolean;
};

export const CountryOptionButton = styled.button<CountryOptionButtonProps>`
  display: grid;
  grid-template-columns: 1.75rem 1fr auto;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  background: ${({ $active }) => ($active ? "var(--color-neutral-dark)" : "transparent")};
  color: var(--color-neutral-white);
  text-align: left;
  cursor: pointer;

  &:hover {
    background: var(--color-neutral-dark);
  }

  .PhoneInputCountryIcon {
    width: 1.75rem;
    height: 1.1667rem;
    border-radius: 2px;
    overflow: hidden;
    box-shadow: none;
  }

  .PhoneInputCountryIcon svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  .country-name {
    overflow: hidden;
    font-size: 0.8125rem;
    font-weight: 700;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .calling-code {
    font-size: 0.75rem;
    color: var(--color-neutral-light);
  }
`;
